<template>
	<div id="app" class="app page-404" ref="app">
		<BlockError :data="DataError"/>
	</div>
</template>

<script>
import BlockError from '@/components/blocks/BlockError.vue';

export default {
	name: 'Error',

	components: {
		BlockError
	},
	data () {
		return {
			DataError: {}
		};
	}
};
</script>
